import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody
} from 'reactstrap';

import Spinner from 'react-spinkit';

import { auth } from '../../../firebase';

const INITIAL_STATE = {
  error: null,
  validCode: null,
  verifiedCode: false,
};

class VerifyEmail extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    // Try to apply the email verification code.
    auth
      .doVerifyEmail(this.props.actionCode)
      .then(() => {
        // Email address has been verified.
        this.setState({ validCode: true, verifiedCode: true });
      }, error => {
        // Code is invalid or expired. Ask the user to verify their email address
        // again.
        this.setState({ error: error.message, validCode: false, verifiedCode: true });
      });
  }

  render() {
    const {
      error,
      validCode,
      verifiedCode,
    } = this.state;

    let component;
    if (!verifiedCode) {
      component = (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <br></br>
                      <Spinner name="ball-clip-rotate-multiple" color="steelblue"/>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (verifiedCode && validCode) {
      component = (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <h3>Email verified successfully</h3>
                      <p>You can now sign in with your new account.</p>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (verifiedCode && !validCode) {
      component = (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <h3>Email verification failed</h3>
                      <p className="error">{error}</p>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return component;
  }
}

export default VerifyEmail;



// WEBPACK FOOTER //
// ./src/views/Pages/VerifyEmail/VerifyEmail.js